module.exports = __webpack_public_path__ + "img/椭圆形(4).3591798e.png";